<template>
	<vxe-modal v-model="show" width="800" show-footer @show="onShow">
		<template #title>
			<span>收款情况</span>
		</template>
		<template #default>
			<div v-if="tableShow">
				<el-divider content-position="left">总金额</el-divider>
				<vxe-table border :data="staticdata">
					<vxe-column field="code" title="父级订单编码"></vxe-column>
					<vxe-column field="amount" title="总金额"></vxe-column>
					<vxe-column field="receivedpayment" title="已收款"></vxe-column>
					<vxe-column field="remaindpayment" title="未收款"></vxe-column>
				</vxe-table>
				<el-divider content-position="left">已收款</el-divider>
				<vxe-table border max-height="300" show-footer :footer-method="tableDatafooter" :data="tableData" style="margin-top: 20px;">
					<vxe-column field="code" title="收款单编码"></vxe-column>
					<vxe-column field="ordercode" title="线上单号"></vxe-column>
					<vxe-column field="orderamount" title="收款金额"></vxe-column>
					<vxe-column field="needamount" title="应收款"></vxe-column>
					<vxe-column field="staffid" title="状态">
						<template #default="{ row }">
							{{row.staffid?'已收款':'当前收款'}}
						</template>
					</vxe-column>
					<vxe-column field="flowstatus" title="审核状态">
						<template #default="{ row }">
							{{row.flowstatus>0?'已审核':'未审核'}}
						</template>
					</vxe-column>
				</vxe-table>
				<el-divider content-position="left">未收款</el-divider>
				<vxe-table border :data="remainorder" show-footer :footer-method="remainorderfooter">
					<vxe-column field="ordercode" title="线上单号"></vxe-column>
					<vxe-column field="orderamount" title="金额"></vxe-column>
				</vxe-table>
			</div>
		</template>
	</vxe-modal>
</template>
<style scoped>

</style>
<script>
	export default {
		props: {
			store: {
				type: Object,
				default: () => {
					return {}
				}
			}
		},
		data() {
			return {
				show: false,
				tableShow: false,
				code:'',
				parentordercode:'',
				wlnorder: [],
				erporder: [],
				tableorder: [],
				remainorder: [],
				staticdata: [{
					code: '',
					amount: 0,
					receivedpayment: 0,
					remaindpayment: 0,
				}],
				tableData: []
			}
		},
		created() {

		},
		mounted() {


		},
		watch: {

		},
		computed: {

		},

		methods: {
			modalshow() {
				this.show = true
			},
			onShow() {
				console.log(this.wlnorder, 'wlnorder')
				console.log(this.erporder, 'erporder')
				console.log(this.tableorder, 'tableorder')
				let staticdata = {
					code: '',
					amount: 0,
					receivedpayment: 0,
					remaindpayment: 0
				}
				let tableData = []
				let remainorder = []
				let relation_data = this.wlnorder.relation_data
				staticdata.code = this.wlnorder.salercpt_no
				relation_data.forEach((item) => {
					item.orders.forEach((oitem)=>{
						staticdata.amount += parseFloat(oitem.payment)
					})
					
				})
				this.erporder.forEach((item) => {
					tableData.push(item)
				})
				this.tableorder.forEach((item) => {
					if (!item.staffid && item.parentordercode == this.parentordercode) {
						tableData.push({
							code: this.code,
							ordercode: item.ordercode,
							orderamount: item.orderamount,
							flowstatus: -1,
							staffid: 0,
						})
					}
				})
				
				tableData.forEach((item) => {
					staticdata.receivedpayment += parseFloat(item.orderamount)
				})
				relation_data.forEach((item) => {
					let index =  tableData.findIndex((_item)=>{
						return item.salercpt_no == _item.ordercode
					})
					if(index==-1){
						remainorder.push({
							ordercode: item.salercpt_no,
							orderamount: item.realPayment,
						})
					}
				})
				
				
				staticdata.remaindpayment = staticdata.amount - staticdata.receivedpayment
				this.staticdata = [staticdata]
				this.tableData = tableData
				this.remainorder = remainorder
				this.tableShow = true

			},
			tableDatafooter(){
				let amount = 0
				this.tableData.forEach((item)=>{
					amount += parseFloat(item.orderamount)
				})
				return [['合计', '', amount, '', '']]
			},
			remainorderfooter(){
				let amount = 0
				this.remainorder.forEach((item)=>{
					amount += parseFloat(item.orderamount)
				})
				return [['合计', amount]]
			}
		},
		components: {

		}
	}
</script>
